export function clampToPositiveNonZeroNumber(value: number, clampValue: number = 0.1) {
  const pattern = /^(0\.\d*[1-9]\d*|[1-9]\d*(\.\d+)?)$/;

  return Number(pattern.test(value.toString()) ? (+value > 0 ? value : clampValue) : clampValue);
}
